import { IValue } from "./ivalue";
import { ControlType } from "../controltype";
import { EventEmitter } from "@angular/core";

export class RadioGroupValue implements IValue {
    value: string;
    clear$ = new EventEmitter();
    constructor(data: string = '') {
        this.value = data;
    }
    clearValue(): void {
        this.value = undefined;
        this.clear$.emit();
    }
    setOriginalValue(value: any): void {
        throw new Error("Method not implemented.");
    }
    getOriginalValue() {
        return this.value;
    }
    getControlType(): ControlType {
        return ControlType.Radio;
    }

    isEmpty(): boolean {
        return !this.value;
    }
    getValueText(): string {
        return this.value;
    }
}
